import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'filters';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const FILTERS_GET = createApiNamespacedConstants('filters_get');
